/* eslint-disable */
// https://dev2.bhsn.it/api/heimdall/swagger-ui/index.html
import type { AxiosPromise, AxiosInstance } from 'axios';
import { toAxiosOptions, mergeObjects } from '@allibee/utils';

let axiosInstance: AxiosInstance;
let baseURL: string;

const serviceRoute = 'heimdall';
export function setupServiceInstance(callback: (serviceRoute: string) => { baseURL: string; instance: AxiosInstance }) {
    const result = callback(serviceRoute);
    axiosInstance = result.instance;
    baseURL = result.baseURL;
}

export function getBaseURL() {
    return baseURL;
}
/**
 * OTP 를 이용한 2FA 인증 로그인 V1
 * @returns HeimdallResponse OK
 * @throws ApiError
 */
export function verifyOtpForLogin(
    {
        xTwoFactorVerificationToken,
        requestBody,
    }: {
        xTwoFactorVerificationToken: string;
        requestBody: HeimdallUserAuthenticationOtpForm;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<HeimdallResponse> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'POST',
                url: '/login/verification/OTP/v1',
                headers: {
                    'X-Two-Factor-Verification-Token': xTwoFactorVerificationToken,
                },
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 로그인 V3
 * @returns HeimdallResponseUserAuthenticationDtoV3 OK
 * @throws ApiError
 */
export function loginV3(
    {
        requestBody,
    }: {
        requestBody: HeimdallLoginForm;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<HeimdallResponseUserAuthenticationDtoV3> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'POST',
                url: '/login/v3',
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * OTP 를 이용한 슈퍼 어드민 전용 2FA 인증 로그인 V1
 * @returns HeimdallResponse OK
 * @throws ApiError
 */
export function verifyOtpForSuperAdminLogin(
    {
        xTwoFactorVerificationToken,
        requestBody,
    }: {
        xTwoFactorVerificationToken: string;
        requestBody: HeimdallUserAuthenticationOtpForm;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<HeimdallResponse> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'POST',
                url: '/login/super-admin/verification/OTP/v1',
                headers: {
                    'X-Two-Factor-Verification-Token': xTwoFactorVerificationToken,
                },
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 슈퍼 어드민 전용 로그인
 * @returns HeimdallResponseUserAuthenticationDtoV3 OK
 * @throws ApiError
 */
export function loginForSuperAdminV3(
    {
        requestBody,
    }: {
        requestBody: HeimdallLoginForm;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<HeimdallResponseUserAuthenticationDtoV3> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'POST',
                url: '/login/super-admin/v3',
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 토큰 유효성 검사
 * @returns HeimdallResponse OK
 * @throws ApiError
 */
export function verifyToken(_?: any, requestConfig?: RequestConfig): AxiosPromise<HeimdallResponse> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/token/verify/v1',
            }),
            requestConfig,
        ),
    );
}
